// Phase 2D.2A — in-memory recovery state.
//
// The password-reset form is unlocked ONLY when Supabase Auth itself emits
// PASSWORD_RECOVERY, i.e. when it has genuinely established a recovery session
// from the one-time link. A URL parameter, a fragment value or an ordinary
// authenticated session is never sufficient.
//
// The listener is installed at application boot (side-effect import in
// ``index.js``) because the SDK emits PASSWORD_RECOVERY on a timer right after
// it parses the landing URL — a listener attached later would miss it.
//
// State lives in memory only. Nothing here writes to localStorage or
// sessionStorage, and nothing is ever logged.

import { supabase } from "./supabase";
import { RECOVERY_LINK, readRecoveryLinkState } from "./recoveryLinkParams";

export const RESET_PASSWORD_PATH = "/auth/reset-password";

let verified = false;
const listeners = new Set();

supabase.auth.onAuthStateChange((event) => {
  if (event === "PASSWORD_RECOVERY") {
    verified = true;
    listeners.forEach((listener) => listener(true));
  }
});

export function isRecoveryVerified() {
  return verified;
}

export function expectsRecovery() {
  return RECOVERY_LINK.looksLikeRecovery || readRecoveryLinkState().looksLikeRecovery;
}

export function recoveryLinkFailed() {
  return RECOVERY_LINK.failed || readRecoveryLinkState().failed;
}

export function recoveryLinkExpired() {
  return RECOVERY_LINK.expired || readRecoveryLinkState().expired;
}

export function subscribeRecovery(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function clearRecoveryState() {
  verified = false;
  listeners.forEach((listener) => listener(false));
}

// The redirect target is derived from the current origin only — never from a
// query parameter, a fragment or any other user-supplied value, so no open
// redirect is possible.
export function passwordResetRedirectUrl() {
  return `${window.location.origin}${RESET_PASSWORD_PATH}`;
}
